import React,{ useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const usePageTracking = () => {
  const location = useLocation();
  function clearAllInterval(){
    for (var i = 1; i < 99999; i++)
        window.clearInterval(i)
  }
  useEffect(() => {
    // Google Analytics 測定 ID を入力して設定
    ReactGA.initialize("G-7W9JKQ50Y6");
    ReactGA.send({
      hitType: "pageview",
      // アクセスしたパス (pathname) とクエリ文字列 (search) を送付する (必要に応じて編集する)
      page: location.pathname + location.search,
    });
    clearAllInterval()
  }, [location]);
};

export default usePageTracking;